import apiClient from './client';
import { API_ENDPOINTS } from './endpoints';

export interface Session {
  id: string;
  source_device: string;
  source_device_name: string;
  target_device: string;
  target_device_name: string;
  initiated_by: string;
  initiated_by_name: string;
  status: string;
  started_at: string;
  ended_at: string | null;
  duration: string | null;
  ip_address: string;
  notes: string;
}

export interface SessionFormData {
  source_device: string;
  target_device: string;
  ip_address: string;
  notes?: string;
}

export const sessionsApi = {
  list: async (params?: Record<string, any>): Promise<{ results: Session[]; count: number }> => {
    const response = await apiClient.get(API_ENDPOINTS.SESSIONS.LIST, { params });
    return response.data;
  },

  get: async (id: string): Promise<Session> => {
    const response = await apiClient.get(API_ENDPOINTS.SESSIONS.DETAIL(id));
    return response.data;
  },

  create: async (data: SessionFormData): Promise<Session> => {
    const response = await apiClient.post(API_ENDPOINTS.SESSIONS.CREATE, data);
    return response.data;
  },

  update: async (id: string, data: Partial<SessionFormData>): Promise<Session> => {
    const response = await apiClient.patch(API_ENDPOINTS.SESSIONS.UPDATE(id), data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.SESSIONS.DELETE(id));
  },
};